import { Type } from 'class-transformer'
import { IsNotEmpty, IsNumber, IsOptional, IsUUID } from 'class-validator'
import _ from 'lodash'
import { BaseSchema } from './BaseSchema'

export class LabSchema extends BaseSchema {
  /**
   * User ID
   */
  @IsOptional()
  @IsUUID()
  id: string

  /**
   * First Name
   */
  @IsNotEmpty()
  name: string = null

  /**
   * Tier
   */
  @Type(() => Number)
  @IsNotEmpty()
  @IsNumber()
  tier: number = 0

  /**
   * Date created
   */
  @Type(() => Date)
  created: Date

  /**
   * Updated by
   */
  createdBy: string

  /**
   * Date updated
   */
  @Type(() => Date)
  updated: Date

  /**
   * Updated by
   */
  updatedBy: string

  /**
   * Date deleted
   */
  @Type(() => Date)
  deleted: Date

  /**
   * Deleted by
   */
  deletedBy: string

  /**
   * Construct
   * @param data
   */
  constructor (data?: Partial<LabSchema>) {
    super()
    _.assign(this, data)
  }
}
